import React, { Fragment } from "react";
import classnames from "classnames";
import { readOnlyValue } from "../../../../../attributes/lib/attribute-data";

const FactItem = (props) => {
    const columnItems = props.data;

    const noteMark = columnItems[0].noteMark || "";
    const factName = columnItems[0].nutrient || "";
    const description = columnItems[0].description || "";

    const columns = columnItems.map((item, c) => {
        const hideEmptyPercent = item.pdv?.value === "" || item.pdv?.value === null ? "-" : readOnlyValue(item.pdv, "Measurement");

        return (
            <Fragment key={`fact_item_fields_${props.factId}_${c}`}>
                <div>
                    {readOnlyValue(
                        { value: item.quantity, uom: item.quantity === "" || item.quantity === null ? { text: "-" } : item.uom },
                        "Measurement"
                    )}
                </div>
                <div>{hideEmptyPercent}</div>
            </Fragment>
        );
    });
    const descText = props.showDescription ? <div className="fact-description">{description}</div> : null;

    return (
        <div
            className={classnames("fact-item", { "-hidden": props.hidden })}
            style={props.columnStyle}
        >
            <div>{readOnlyValue(noteMark, "DropdownPickList")}</div>
            <div>{readOnlyValue(factName, "DropdownPickList")}</div>

            {columns}
            {descText}
        </div>
    );
};

export default FactItem;
